import { render, staticRenderFns } from "./save_confirmation.vue?vue&type=template&id=63f9961a&"
import script from "./save_confirmation.vue?vue&type=script&lang=js&"
export * from "./save_confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./save_confirmation.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports